<img *ngIf="!risklevelvalue" src="assets/risk-level/no-data.svg">
<img *ngIf="risklevelvalue == -1" src="assets/risk-level/no-data.svg">
<img *ngIf="risklevelvalue == 1" src="assets/risk-level/risk_level_green.svg">
<img *ngIf="risklevelvalue == 2" src="assets/risk-level/risk_level_yellow.svg">
<img *ngIf="risklevelvalue == 3" src="assets/risk-level/risk_level_red.svg">
<br />
